import React from 'react';
import './ResponsiveTable.css';

const ResponsiveTable = React.forwardRef(function ResponsiveTable(props, ref) {
    return <div className="modern-data-table table-modern-card">
        <div className="table-modern-scroll" role="region" aria-label={props['aria-label'] || 'Tabela de dados'} tabIndex={0}>
            <table {...props} ref={ref} />
        </div>
    </div>;
});

export default ResponsiveTable;
